<template>
    <div class="bg-amber-500 text-white px-4 py-2.5 flex items-center justify-between z-50 w-full">
        <div class="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span class="text-body-6 font-medium">
                You are viewing as: <strong>{{ memberName }}</strong>
                <span v-if="memberEmail" class="opacity-80">({{ memberEmail }})</span>
                <span v-if="remainingTime" class="ml-2 opacity-80">- {{ remainingTime }}</span>
            </span>
        </div>
        <button
            @click="stopImpersonation"
            class="bg-white text-amber-600 px-3 py-1 rounded text-body-6 font-medium hover:bg-amber-50 transition-colors flex-shrink-0"
        >
            Stop Viewing
        </button>
    </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
import { useAuth } from '@/stores/AuthStore';

const authStore = useAuth();
const now = ref(Date.now());
let timer = null;

const memberName = computed(() => {
    if (!authStore.member) return '';
    return `${authStore.member.first_name} ${authStore.member.last_name}`;
});

const memberEmail = computed(() => {
    return authStore.member?.primary_email || '';
});

const remainingTime = computed(() => {
    if (!authStore.impersonationExpiresAt) return null;

    const expiresAt = new Date(authStore.impersonationExpiresAt).getTime();
    const diff = Math.max(0, Math.floor((expiresAt - now.value) / 1000));

    if (diff <= 0) return 'Expired';

    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')} remaining`;
});

onMounted(() => {
    timer = setInterval(() => {
        now.value = Date.now();

        if (!authStore.impersonationExpiresAt) return;

        const expiresAt = new Date(authStore.impersonationExpiresAt).getTime();
        const secondsLeft = Math.floor((expiresAt - Date.now()) / 1000);

        if (secondsLeft <= 30) {
            clearInterval(timer);
            authStore.stopImpersonation();
        }
    }, 1000);
});

onBeforeUnmount(() => {
    if (timer) clearInterval(timer);
});

async function stopImpersonation() {
    await authStore.stopImpersonation();
}
</script>
